// extracted by mini-css-extract-plugin
export default {"text--blue":"baseChartTooltipWithHeader_text--blue__zqGJZ","text--bold":"baseChartTooltipWithHeader_text--bold__q3X0E"};